module.exports = __webpack_public_path__ + "static/assets/bfe36e0adb379224a89cb7b6864e3274.png";